import generatedArticles from '@articles/articleSummaries.json';

export type Article = {
  title: string;
  slug: string;
  description: string;
  image?: string;
  imageAlt?: string;
  socialImage?: string;
  category: 'Comparisons' | 'Guides' | 'Wallet infrastructure';
  publishedAt: string;
  updatedAt?: string;
  status: 'published' | 'draft';
  featured: boolean;
  example: boolean;
  readingTime: number;
  body: string;
  toc: Array<{ title: string; url: string; items?: Article['toc'] }>;
};
export type ArticleSummary = Omit<Article, 'body'>;

// Velite validates this data before either webpack build starts.
export const articles = generatedArticles as ArticleSummary[];

export function getRelatedArticles(article: ArticleSummary, limit = 3) {
  return articles
    .filter((candidate) => candidate.slug !== article.slug)
    .sort(
      (a, b) =>
        Number(b.category === article.category) -
        Number(a.category === article.category)
    )
    .slice(0, limit);
}
